import React from 'react'
import StudentSummary from '../../Dashboard/StudentSummary/StudentSummary'

// MF-542 — the Student Summary dashboard (greeting + photo + per-term KPI cards) as a bi-custom
// Analytics chart, added/assigned via Analytics Charts (who sees it / default per role). It renders
// the logged-in student's own summary (nothing for non-students).
const StudentSummaryReport = () => <StudentSummary />

export default StudentSummaryReport
